import React, { ReactEventHandler } from 'react'
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { FaPlus } from "react-icons/fa";
import { addPurposeApi, fetchPurposeApi, updatePurposeTypeApi } from "../api/PurposeType";
import toast from "react-hot-toast";
import SideModal from '../../Components/general/Sidemodal';


interface PurposeProps {
  url: string;
}

export const PurposeType = ({ url }: PurposeProps) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddingSubType, setIsAddingSubType] = useState(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const [name, setName] = useState<string>("");

  const [purposeType, setPurposeType] = useState<any[]>([]);

  const [hiddenforUser, sethiddenforUser] = useState(false);

  const [allData, setAllData] = useState<any[]>([])
  const [refresh, setRefresh] = useState(false);
  const [ids, setIds] = useState<string>("");


  const fetchPurposeTypeData = async () => {
    const data = await fetchPurposeApi(url);

    if (data && Array.isArray(data)) {
      const uniquePurposeType = data.reduce((acc: any[], item: any) => {
        if (!item.parentId && !acc.some((t) => t.name === item.name)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setPurposeType(uniquePurposeType);
    } else {
      console.error("Failed to fetch taxonomies");
    }
  };

  useEffect(() => {
    fetchPurposeTypeData();
  }, [refresh]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(purposeType.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const paginatedPurpose = purposeType.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNavigation = (event: React.MouseEvent, path: string) => {
    event.preventDefault();
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  const handleViewClick = (
    event: React.MouseEvent,
    path: string,
    id: string,
    name: string
  ) => {
    event.preventDefault();

    const queryParams = new URLSearchParams({ id, name });
    const fullPath = `${path}${queryParams.toString()}`;

    window.history.pushState({ id, name }, "", fullPath);

    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setIsEditMode(false);
    setIsAddingSubType(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setName("");
  }


  const handleSubmitClick = async () => {
    if (!name) {
      toast.error("Please fill details");
      return;
    }
    try {
      if (isEditMode) {
        await updatePurposeTypeApi(url, ids, name, hiddenforUser);
        toast.success("Template updated successfully");
        handleCloseModal();
      } else {
        const data = await addPurposeApi(url, name, hiddenforUser);
        toast.success("Donation Type added successfully");
        handleCloseModal();
      }
      setRefresh((prev) => !prev);

    } catch (error) {
      toast.error("Failed to add subtype");
    }
  }

  const handleEditClick = (index: number, id: string) => {
    const item = purposeType.find((Data) => Data.id === id);

    if (!item) {
      console.error("child not found");
      return;
    }


    setIds(item.id);
    setName(item.name);
    sethiddenforUser(item.isHiddenForUser);
    setIsModalOpen(true);
    setIsEditMode(true);
  };




  return (
    <div className="px-2 md:px-4 mt-6 h-full">
      <div>
        <div className='flex flex-row items-center '>
          <h1 className="text-3xl font-bold text-blue-600 mb-5">Purpose Type</h1>
          <button
            type="button"
            className=" w-fit px-3 py-2 mx-3 mb-4 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
            onClick={handleOpenModal}
          >
            <FaPlus className="w-3 h-3" />
          </button>
        </div>

        <div className="flex-grow ml-0 w-full mt-10">
          <form className="w-full ">
            <label
              htmlFor="default-search"
              className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div className="relative w-full">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                className="inline-block min-w-full p-3 ps-10 outline-none text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search Taxonomies"
                required
              />
              <button
                type="submit"
                className="text-white absolute end-1.5 bottom-1.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Search
              </button>
            </div>
          </form>
        </div>
        <div className="flex-grow ml-0 w-3/4">
          <form className="w-auto">{/* Search Form */}</form>
        </div>
        <div className="flex-grow ml-0 mt-4 w-full">
          <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg mt-6">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                    style={{ width: "200px" }}
                  >
                    Actions
                  </th>
                  <th
                    scope="col"
                    className="py-3.5 px-4 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                  >
                    Name
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                {paginatedPurpose
                  .map((purpose, index) => (
                    <tr key={purpose.id || index}>
                      <td className="px-4 py-4 text-sm whitespace-nowrap">
                        <div className="flex items-center gap-x-6">
                          <button
                            type="button"
                            onClick={() => handleEditClick(index, purpose.id)}

                            className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                          >
                            {/* Edit icon */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-5 h-5"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                              />
                            </svg>
                          </button>
                        </div>
                      </td>
                      <td className="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">
                        <div className="inline-flex items-center gap-x-3">
                          <div className="flex items-center gap-x-2">
                            <div>
                              <h2 className="  text-sm font-medium text-gray-800 dark:text-white ">
                                {purpose.name}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>



          {/* side modal */}
          <SideModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

            <div className="p-6">
              <div className="flex justify-between">
                <h2 className="text-xl font-bold  text-blue-600 mb-4 ">
                  {isEditMode ? "Edit" : "Add"}
                </h2>
                <button
                  onClick={handleCloseModal}
                  className="text-xl text-gray-600 dark:text-gray-400 h-6 w-6"
                >
                  &times;
                </button>
              </div>

              <>
                <label className="text-gray-900 dark:text-gray-200 font-semibold">
                  Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Value"
                  className="w-full px-4 py-2 mt-2 mb-4 border border-gray-300 rounded-md"
                />

                <div className="flex items-center space-x-2 mt-2 mb-4">
                  <input
                    type="checkbox"
                    checked={hiddenforUser}
                    onChange={(e) => sethiddenforUser(e.target.checked)}
                    className="w-4 h-4 accent-blue-500"
                  />
                  <label className="text-gray-900 dark:text-gray-200 font-semibold">
                    Don't show to user
                  </label>
                </div>

                <div className="flex space-x-4 justify-end">
                  <button
                    onClick={handleSubmitClick}
                    className="px-8 py-2.5 leading-5 text-white transition-colors duration-300 transform bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none focus:bg-gray-600"
                  >
                    {isEditMode ? "Update" : "Add"}
                  </button>
                  <button
                    onClick={handleCloseModal}
                    className="px-8 py-2.5 leading-5 bg-gray-300 rounded-md"
                  >
                    Cancel
                  </button>
                </div>
              </>
            </div>

          </SideModal>

          <div className="flex items-center justify-between mt-6">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-5 h-5 rtl:-scale-x-100"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                />
              </svg>

              <span>previous</span>
            </button>

            <div className="items-center hidden lg:flex gap-x-3">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageClick(index + 1)}
                  className={`px-2 py-1 text-sm ${currentPage === index + 1
                    ? "text-blue-500 bg-blue-100"
                    : "text-gray-500 hover:bg-gray-100"
                    } rounded-md`}
                >
                  {index + 1}
                </button>
              ))}
            </div>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <span>Next</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-5 h-5 rtl:-scale-x-100"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
